import { financingPageBreadcrumb } from '@/components/ui/Breadcrumbs/constants'
import { messages } from './messages'

export const DETAILS = [
  messages.financingOffer.details.advancePayment,
  messages.financingOffer.details.amountOfLeasing,
  messages.financingOffer.details.preliminaryDecision,
  messages.financingOffer.details.deadline,
  messages.financingOffer.details.discount,
]

export const BENEFITS = [
  {
    icon: 'calender',
    description: messages.benefits.description.first,
    tagName: 'p',
    className: 'color_pale-black',
  },
  {
    icon: 'costs',
    description: messages.benefits.description.second,
    tagName: 'p',
    className: 'color_pale-black',
  },
  {
    icon: 'price',
    description: messages.benefits.description.third,
    tagName: 'p',
    className: 'color_pale-black',
  },
]

export const STEPS = [messages.steps[1], messages.steps[2], messages.steps[3], messages.steps[4], messages.steps[5]]

export const BANNER_BENEFITS = [
  messages.benefits.banner.benefits.machines,
  messages.benefits.banner.benefits.accreditation,
  messages.benefits.banner.benefits.machineAge,
  messages.benefits.banner.benefits.conditions,
]

export const ROOT_BREADCRUMBS = [financingPageBreadcrumb]
export const PARTNER_IMAGES = ['alfa-leasing']
